var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.item)?_c('div',{staticStyle:{"padding-top":"10px","padding-bottom":"10px"}},[_c('a',{staticClass:"btn btn-sm btn-warning",attrs:{"href":"javascript:void(0);","title":"Link Work Item"},on:{"click":function($event){return _vm.linkWorkItem(_vm.item)}}},[_c('i',{staticClass:"fa fa-link"}),_vm._v(" Link")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }